import { render, staticRenderFns } from "./user-points.vue?vue&type=template&id=840d9a44&scoped=true&"
import script from "./user-points.vue?vue&type=script&lang=js&"
export * from "./user-points.vue?vue&type=script&lang=js&"
import style0 from "./user-points.vue?vue&type=style&index=0&id=840d9a44&lang=scss&scoped=true&"
import style1 from "./user-points.vue?vue&type=style&index=1&id=840d9a44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840d9a44",
  null
  
)

export default component.exports